import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import Grid from '@magalu/stereo-ui/atoms/Grid';
import { getMediaQuery } from '@magalu/stereo-ui-styles';
export var ServicesGrid = styled(Grid)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: grid;\n  grid-gap: 8px;\n  grid-template-columns: minmax(0, 1fr);\n  ", " {\n    grid-template-columns: ", ";\n  }\n"])), getMediaQuery('small'), function (props) {
  return "repeat(".concat(props.nCards || 1, ", 1fr)");
});